export default __webpack_public_path__ + "static/media/central_andes_2_22.c8a9f31a.JPG";